import { render, staticRenderFns } from "./StrategyItem.vue?vue&type=template&id=10eaa7c8&scoped=true&"
import script from "./StrategyItem.vue?vue&type=script&lang=js&"
export * from "./StrategyItem.vue?vue&type=script&lang=js&"
import style0 from "./StrategyItem.vue?vue&type=style&index=0&id=10eaa7c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10eaa7c8",
  null
  
)

export default component.exports